import dayjs from 'dayjs'
import { formatDate } from '../../utils/common'
import { IntakeCardProps } from './IntakeCard'
import { IntakeField } from './_styles'

export const IntakeDate = ({ intake }: IntakeCardProps) => {
  const { intakeStartDate, intakeEndDate } = intake

  if (!intakeStartDate && !intakeEndDate) return null

  let str = ''

  const differenceInDays = dayjs(intakeEndDate).diff(dayjs(intakeStartDate), 'day')

  if (intakeStartDate) str += formatDate(intakeStartDate, 'DD MMMM YYYY')
  if (!!intakeStartDate && !!intakeEndDate && differenceInDays > 1) {
    str += ` - `
  }
  if (intakeEndDate && differenceInDays > 1) str += formatDate(intakeEndDate, 'DD MMMM YYYY')

  return (
    <IntakeField>
      <span>Date:</span> {str}
    </IntakeField>
  )
}
